import { Clip } from '@/shared/models/clip.model';

/**
 * A clip qualifies for the scouting (wide-angle) feed only when it has BOTH a
 * tactic video URL and a tactic start frame. Frame 0 is valid — only null/undefined disqualifies.
 */
export function isScoutingFeedClip(clip: Clip | null | undefined): boolean {
  return !!clip?.tacticUrl && clip?.tacticStartFrame != null;
}

/** Everything after `media/videos/` in a clip's raw storage URL — the wide-angle
 * subpath varies per camera provider (e.g. `wide-angle/spiideo/`), so it must be
 * read from the URL itself rather than assumed as a fixed subfolder. */
export function extractVideoRelativePath(url: string | null | undefined): string | null {
  const marker = 'media/videos/';
  const index = url?.indexOf(marker) ?? -1;
  return index === -1 ? null : (url as string).slice(index + marker.length);
}
